import React from "react";
import { Props } from "./types";

function PlusIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 24 24">
      <path
        d="M5 12H19"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5L12 19"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { PlusIcon };
